module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SEO标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "disabled": _vm.disabled,
      "size": "medium",
      "placeholder": ""
    },
    model: {
      value: (_vm.params.seoTitle),
      callback: function($$v) {
        _vm.$set(_vm.params, "seoTitle", $$v)
      },
      expression: "params.seoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SEO描述"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "textarea"
    },
    model: {
      value: (_vm.params.seoDesc),
      callback: function($$v) {
        _vm.$set(_vm.params, "seoDesc", $$v)
      },
      expression: "params.seoDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息属性"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.selSheckbox
    },
    model: {
      value: (_vm.articleProp),
      callback: function($$v) {
        _vm.articleProp = $$v
      },
      expression: "articleProp"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("推荐")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("热门")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("置顶")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "浏览量"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled,
      "controls-position": "right",
      "min": 1
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.params.views),
      callback: function($$v) {
        _vm.$set(_vm.params, "views", $$v)
      },
      expression: "params.views"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息页模板"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.params.modelLink),
      callback: function($$v) {
        _vm.$set(_vm.params, "modelLink", $$v)
      },
      expression: "params.modelLink"
    }
  }), _vm._v("\n            不填写则继承栏目设置中的内容模板\n        ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自定义链接"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "disabled": _vm.disabled,
      "size": "medium"
    },
    model: {
      value: (_vm.params.customLink),
      callback: function($$v) {
        _vm.$set(_vm.params, "customLink", $$v)
      },
      expression: "params.customLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布者"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "disabled": _vm.disabled,
      "size": "medium"
    },
    model: {
      value: (_vm.params.issuer),
      callback: function($$v) {
        _vm.$set(_vm.params, "issuer", $$v)
      },
      expression: "params.issuer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.disabled,
      "align": "right",
      "type": "date",
      "placeholder": "默认显示当前日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.params.data),
      callback: function($$v) {
        _vm.$set(_vm.params, "data", $$v)
      },
      expression: "params.data"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-49953e81"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/article/article_examine/add/src/Subpage2.vue
// module id = 1478
// module chunks = 1